import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { SeoMeta } from '../../../../components/SeoMeta'
import { MagnoliaPage } from '../../MagnoliaApp'

import { LookupPageView } from './LookupPageView'

interface OrderLookupPageProps {
  errors: Array<Error>
  loading: boolean
}

export const OrderLookupPage: MagnoliaPage<OrderLookupPageProps> = () => {
  const {
    magnolia: { orders: strings },
  } = useTranslation()

  return (
    <>
      <SeoMeta title={strings.pageTitle} />
      <LookupPageView />
    </>
  )
}
